module.exports = __webpack_public_path__ + "img/thumbnail_Emu_j_leucistic.6c07f7dc.png";